import { render } from "./CIS-Profile.vue?vue&type=template&id=9fa0b534&scoped=true"
import script from "./CIS-Profile.vue?vue&type=script&lang=js"
export * from "./CIS-Profile.vue?vue&type=script&lang=js"

import "./CIS-Profile.vue?vue&type=style&index=0&id=9fa0b534&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa0b534"]])

export default __exports__